import { StateCreator } from "zustand";
import { FetchState } from "../../../domain/models/fetch-state";
import { AxiosHttpClient } from "../../../infra/http/axios-http-client";
import {
  AUTH_HEADER,
  SECURE_AUTH_TOKEN_KEY,
  SECURE_BASE_URL_KEY,
} from "../../../base";
import Endpoints from "../../../domain/endpoints";
import { getDataKeyFromLocalStorage } from "../../../common/utils/AuthToken";
import { FetchMonthlySmartFillType } from "../../../domain/models/monthly-tour-program/fetch-monthly-smart-fill";
import { RemoteFetchMonthlySmartFill } from "../../../data/usecases/monthly-tour-program/remote-fetch-monthly-smart-fill";

export interface FetchMonthlySmartFillInterface {
  FetchMonthlySmartFillState: FetchState;
  fetchMonthlySmartFill: Function;
}

const initialStates = {
  FetchMonthlySmartFillState: FetchState.DEFAULT,
};

const axiosHttpClient = AxiosHttpClient.getInstance();

export const useFetchMonthlySmartFillSlice: StateCreator<
  FetchMonthlySmartFillInterface
> = (set) => ({
  ...initialStates,
  fetchMonthlySmartFill: async (month: number, year: number) => {
    const token = getDataKeyFromLocalStorage(SECURE_AUTH_TOKEN_KEY) ?? "";
    const BASE_URL = getDataKeyFromLocalStorage(SECURE_BASE_URL_KEY);

    axiosHttpClient.setAuthHeaders({
      [AUTH_HEADER]: token.toString(),
    });

    const remoteFetchMonthlySmartFill = new RemoteFetchMonthlySmartFill(
      `${BASE_URL}${Endpoints.FETCH_MONTHLY_SMART_FILL}`,
      axiosHttpClient
    );

    set(() => ({ FetchMonthlySmartFillState: FetchState.LOADING }));
    let result = await remoteFetchMonthlySmartFill.fetch(month, year);
    return result;
  },
});
